//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import md5 from './js/md5';
export default {
  data(){
    return {
        name:''
    }
  },
  methods:{
    look(){
      window.location.href ='http://app.cdxt.com.cn/scvif/pages/publicRegistration.html?t='+this.time1 +'&mobile='+this.mobile+'&cid='+this.cid+'&sign=' + this.sign;
    }
  },
  mounted(){
    var date = new Date();
    this.time1 = date.valueOf();
    this.mobile = this.$route.query.mobile;
    this.cid = this.$route.query.cid;
    this.name = this.$route.query.name;
    this.sign = md5(this.mobile+this.cid+'wei%23Weiwe&@T2w');
    console.log(this.sign,this.mobile,this.cid)

  }
}



// WEBPACK FOOTER //
// ./src/project/articleProject/wrapping.vue